import React from "react";
import withAuth from "@irati/auth/helpers/auth/withAuth";
import { CompanyNewsTileType } from "@irati/types";
import Button from "@irati/ui/src/Button";
import FormattedMessage from "@irati/utils/lang";
import { updateCompanyNewsTile } from "@irati/homepage/services/homepage";
import tracking from "@irati-tracking/homepage";
import { Body, H4 } from "@irati/ui/src/Typography";
import { Modal } from "../Modal";
import { ModalContent, StyledFooter } from "../Modal/styled";
var deleteTile = function (tileToUpdate, onClose, businessId) {
    var tile = {
        config: {
            columnWidth: tileToUpdate.config.columnWidth,
            type: CompanyNewsTileType.Empty,
            // reset the tiles values back to empty
            backgroundColor: undefined,
            imageUrl: undefined,
            message: undefined,
            templateIcon: undefined,
            templateText: undefined,
            url: undefined,
            videoUrl: undefined
        },
        xpos: tileToUpdate.xpos,
        ypos: tileToUpdate.ypos
    };
    var variables = {
        tenantId: businessId,
        tile: tile
    };
    // @todo loading
    // ts error due to required types (not required by graph)
    // @ts-ignore
    updateCompanyNewsTile(variables).then(function () {
        tracking.homePageDeleteTile();
        onClose();
    });
};
var DeleteTileModal = function (_a) {
    var companyNewsTile = _a.companyNewsTile, onClose = _a.onClose, auth = _a.auth;
    return (React.createElement(Modal, { header: React.createElement(H4, null,
            React.createElement(FormattedMessage, { id: "platform.homepage.companyNews.deleteTile.title" })), onClose: onClose },
        React.createElement(React.Fragment, null,
            React.createElement(ModalContent, null,
                React.createElement(Body, null,
                    React.createElement(FormattedMessage, { id: "platform.homepage.companyNews.deleteTile.message" }))),
            React.createElement(StyledFooter, null,
                React.createElement(Button, { tertiary: true, onClick: onClose },
                    React.createElement(FormattedMessage, { id: "platform.homepage.companyNews.deleteTile.cancel" })),
                React.createElement(Button, { primary: true, marginLeft: 2, onClick: function () { return deleteTile(companyNewsTile, onClose, auth.business.uuid); } },
                    React.createElement(FormattedMessage, { id: "platform.homepage.companyNews.deleteTile.delete" }))))));
};
export default withAuth(DeleteTileModal);
